// @flow
import { random } from 'lodash';

import { type IconName } from 'Components/frameworks/icon/Icon.jsx';

export type CMSProps = {
  resortId: string,
  header: string,
  icon: IconName,
  collapseLabels: {
    expand: string,
    collapse: string,
  },
  config?: CMSContent,
};

export function props() {
  return {
    componentId: () => `collapse-panel-${random(1000, 10000)}`,
    collapseLabel: ({ collapseLabels }: CMSProps) => collapseLabels.collapse || '',
    expandLabel: ({ collapseLabels }: CMSProps) => collapseLabels.expand || '',
    displayed: () => true,
  };
}
